<template>
    <div class="row">
    <div class="col-12 layoutPadding-30" style="/*padding:0*/">
      <div
        class="row mb-3"
        style="justify-content: space-between; margin: auto"
      >
        <div class="team-title mt-2 d-flex">
          <i class="material-icons-outlined user-font mr-2 material-icon-font"
            >monetization_on</i
          >
          <div style="margin-top: auto; margin-bottom: auto">Summary</div>
        </div>
      </div>
      <b-tabs v-model="tabIndex" class="spvTabs">
        <b-tab
          title="Overview"
        >
          <spv-allocations></spv-allocations>
        </b-tab>
        <b-tab></b-tab>
        <b-tab title="SPV Setup" @click="handleSpvSetupClick"></b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
import SPVAllocations from './SPVAllocations.vue';
export default {
    name: "spvsummary",
    components: {
        [SPVAllocations.name]: SPVAllocations
    },
    data() {
        return {
        tabIndex: 0,
        chek: 0,
        showOverview: false,
        };
    },
    methods:{
      handleSpvSetupClick(){
        console.log("clicked : ", this.$route.params.account_id);
        this.$router.push(`/${this.$route.params.account_id}/create/workspace?workspace_type=SPV`)
      }
    }
}
</script>
<style>

.spvTabs .nav-tabs li:nth-child(2) {
  visibility: hidden;
  flex-grow: 1;
}

</style>